import * as yup from 'yup';

export const CreateStudyAssignmentValidationSchema = yup.object().shape({
	site_access_ids: yup
		.array()
		.of(yup.number().required())
		.min(1, 'At least one user is required')
		.required(),
});

export const UnassignStudyAssignmentValidationSchema = yup.object().shape({
	study_assignment_ids: yup
		.array()
		.of(yup.number().required())
		.min(1, 'At least one user is required')
		.required(),
});
